<template>
  <div>
    <b-overlay :show="showSpinner" rounded="sm">
      <div class="main-container p-3">
        <div
          class="
            dashboardAdmin-header
            d-flex
            align-items-center
            justify-content-between
          "
        >
          <div class="d-flex align-items-center">
            <div class="dashboardAdmin-header-main-head ml-2">
              <span>Panel Feedback</span>
            </div>
          </div>
        </div>
        <div class="ext-panelist-main-container mt-3">
          <div class="d-flex h-100" v-if="showSpinner == false">
            <div class="w-60 pr-2 overflow-auto m-3">
              <div class="ext-job-detail-container p-2">
                <div class="ext-panelist-card-headings">Job Details</div>
                <div class="ml-3">
                  <div class="mt-2">
                    <div class="ext-panelist-card-main-heads">Job Name</div>
                    <div class="ext-panelist-card-sub-heads">{{ jdName }}</div>
                  </div>
                  <div class="mt-2">
                    <div class="ext-panelist-card-main-heads">
                      Time Scheduled
                    </div>
                    <div class="ext-panelist-card-sub-heads">
                      {{ interviewDetails.formattedStart }}
                    </div>
                  </div>
                  <div class="mt-2">
                    <div class="ext-panelist-card-main-heads">Panel</div>
                    <div class="d-flex flex-wrap">
                      <div>
                        <div class="ext-panelist-card-sub-heads">
                          {{ combinedPanelists[0] }}
                        </div>
                      </div>
                      <div
                        class="ext-panelist-card-sub-heads"
                        v-if="combinedPanelists[1].length == 0"
                      >
                        --
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="ext-job-detail-container mt-3 p-2">
                <div class="d-flex align-items-center justify-content-between">
                  <div class="ext-panelist-card-headings">
                    Candidate Details
                  </div>
                  <div
                    class="extpanelist-blue-text pointer"
                    @click="exportResume(candidateInfo)"
                  >
                    <img
                      src="../../assets/Download (3).svg"
                      class="mr-2"
                      alt=""
                    />
                    Download Resume
                  </div>
                </div>
                <div class="ml-3">
                  <div class="mt-2">
                    <div class="ext-panelist-card-main-heads">
                      Candidate Name
                    </div>
                    <div class="ext-panelist-card-sub-heads">
                      {{ candidateInfo.fullName }}
                    </div>
                  </div>
                  <div class="mt-2">
                    <div class="ext-panelist-card-main-heads">Email</div>
                    <div class="ext-panelist-card-sub-heads">
                      {{ candidateInfo.email }}
                    </div>
                  </div>
                  <div class="mt-2">
                    <div class="ext-panelist-card-main-heads">Contact No.</div>
                    <div class="ext-panelist-card-sub-heads">
                      {{ candidateInfo.phoneNumber }}
                    </div>
                  </div>
                  <div class="mt-2">
                    <div class="ext-panelist-card-main-heads">
                      Education Qualification
                    </div>
                    <div class="ext-panelist-card-sub-heads">
                      {{ candidateInfo.qualification }}
                    </div>
                    <div
                      class="ext-panelist-card-sub-heads"
                      v-if="
                        candidateInfo.qualification == null ||
                        candidateInfo.qualification == ''
                      "
                    >
                      --
                    </div>
                  </div>
                  <div class="mt-2">
                    <div class="ext-panelist-card-main-heads">Skills</div>
                    <div class="d-flex flex-wrap">
                      <div
                        v-for="(skills, index) in candidateInfo.skills"
                        :key="index"
                      >
                        <div class="ext-panelist-card-sub-heads">
                          {{ skills }}
                          <span v-if="index < candidateInfo.skills.length - 1"
                            >,</span
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              class="
                w-40
                h-95
                ext-panelist-right-container
                my-3
                mr-3
                position-relative
              "
              v-if="interviewDetails.feedback == false"
            >
              <div class="ext-panelist-card-headings my-2 pl-3 pt-2">
                Give Feedback
              </div>
              <hr />
              <div class="h-75">
                <div class="px-3 h-100">
                  <div
                    class="h-100 overflow-auto newInt-preview-container pr-2"
                  >
                    <div class="position-relative" v-if="showRecOptions">
                      <SelectCustom
                        :mandatory="true"
                        :placeholder="'Select'"
                        :values="getFilteredRecOptions"
                        :dropdown="true"
                        @select-value="
                          (recOption = $event),
                            (recommendation =
                              thirdPartyData.recommendationKey[$event])
                        "
                        :vmodel="recOption"
                        :label="'Recommendation'"
                        :showError="$v.recOption.$error"
                      />
                      <div v-if="$v.recOption.$error" class="error-txt-tc">
                        Required
                      </div>
                    </div>
                    <div v-else class="">
                      <div class="extp-recom-txt">
                        Recommendations<span class="asterik">*</span>
                      </div>
                      <div
                        class="d-flex align-items-center mt-2"
                        :class="
                          $v.recommendation.$error
                            ? 'recomendation-error'
                            : 'allocateradios'
                        "
                      >
                        <b-form-radio
                          v-model="recommendation"
                          name="some-radios"
                          value="S"
                        >
                          Select
                        </b-form-radio>
                        <b-form-radio
                          v-model="recommendation"
                          name="some-radios"
                          value="R"
                          class="ml-3"
                        >
                          Reject
                        </b-form-radio>
                        <b-form-radio
                          v-model="recommendation"
                          name="some-radios"
                          value="H"
                          v-if="!automatic"
                          class="ml-3"
                        >
                          Hold
                        </b-form-radio>
                        <b-form-radio
                          v-model="recommendation"
                          name="some-radios"
                          value="DNA"
                          class="ml-3"
                        >
                          No Show
                        </b-form-radio>
                      </div>
                    </div>
                    <div>
                      <div class="jdk-ip-confirm-subtxt mt-3">
                        Remarks<span class="asterik">*</span>
                      </div>

                      <div class="mt-1">
                        <b-form-textarea
                          class="newInt-previewInputField"
                          placeholder="Enter"
                          v-model="recruiterRemarks"
                          rows="3"
                          max-rows="4"
                          :class="{
                            error:
                              $v.recruiterRemarks.$error ||
                              !$v.recruiterRemarks.maxLength,
                          }"
                        >
                        </b-form-textarea>
                        <div
                          v-if="!$v.recruiterRemarks.maxLength"
                          class="error-txt-tc"
                        >
                          Exceeded the max char length of 256
                        </div>
                        <div
                          v-else-if="$v.recOption.$error"
                          class="error-txt-tc"
                        >
                          Required
                        </div>
                      </div>
                    </div>
                    <hr class="my-3" />
                    <div class="mt-3 extp-basicinfomartion">
                      <div class="newInt-preview-container-head">
                        Basic Info
                      </div>

                      <div class="mt-3 d-flex align-items-center">
                        <div class="extp-bi-heads" style="width: 40%">
                          Candidate Name
                        </div>

                        <div style="width: 60%">
                          <b-form-input
                            class="w-100"
                            v-model="candidateInfo.fullName"
                            disabled
                          >
                          </b-form-input>
                        </div>
                      </div>

                      <div class="mt-3 d-flex align-items-center">
                        <div class="extp-bi-heads" style="width: 40%">
                          Evaluation Date
                        </div>

                        <div style="width: 60%">
                          <b-form-input
                            class="w-100"
                            v-model="getCurrentDate"
                            disabled
                          >
                          </b-form-input>
                        </div>
                      </div>

                      <div class="mt-3 d-flex align-items-center">
                        <div class="extp-bi-heads" style="width: 40%">
                          Panel Name
                        </div>

                        <div style="width: 60%">
                          <b-form-input
                            class="w-100"
                            v-model="panelName"
                            disabled
                          >
                          </b-form-input>
                        </div>
                      </div>
                      <div class="mt-3 d-flex align-items-center">
                        <div class="extp-bi-heads" style="width: 40%">
                          Mode of Interview
                        </div>

                        <div style="width: 60%">
                          <b-form-input
                            class="w-100"
                            value="Face to Face"
                            disabled
                          >
                          </b-form-input>
                        </div>
                      </div>
                    </div>

                    <template
                      v-if="recommendation != 'DNA' && recommendation != 'NI'"
                    >
                      <div
                        :class="{
                          error:
                            $v.skills.$each[index].mark.$error ||
                            $v.skills.$each[index].comments.$error ||
                            !$v.skills.$each[index].mark.between ||
                            !$v.skills.$each[index].comments.maxLength,
                        }"
                        class="mt-3 givefdbck-blue-containers"
                        v-for="(input, index) in skills"
                        :key="index"
                      >
                        <div>
                          <div
                            class="
                              w-100
                              exptp-inner-containers-head
                              text-truncate
                            "
                          >
                            {{ input.name }}<span class="asterik">*</span>
                          </div>

                          <div
                            class="d-flex align-items-center"
                            v-if="input.markingType == 'rating'"
                          >
                            <div class="newInt-inner-containers-subhead">
                              Rating
                            </div>
                            <div class="extpanelist-rating-input">
                              <b-form-rating
                                variant="primary"
                                v-model="input.mark"
                                class="newInt-rating p-0 w-25 ml-2"
                              ></b-form-rating>
                            </div>
                          </div>

                          <div class="mt-2" v-if="input.markingType == 'score'">
                            <div class="topDiv d-flex align-items-center">
                              <div>
                                <label class="newInt-inner-containers-subhead"
                                  >Score</label
                                >
                              </div>
                              <div class="ml-2">
                                <b-form-input
                                  class="p-1 h37-w44 newInt-previewInputField"
                                  v-model="input.mark"
                                  type="number"
                                >
                                </b-form-input>
                              </div>
                              <div
                                class="ml-1 newInt-preview-container-subFont"
                              >
                                Out of 10
                              </div>
                            </div>
                            <div
                              class="error-txt-tc ml-2"
                              v-if="!$v.skills.$each[index].mark.between"
                            >
                              Should be between 1 to 10
                            </div>
                          </div>

                          <div
                            class="mt-1"
                            :class="
                              input.markingType == 'rating' ? 'mb-2' : 'mb-0'
                            "
                            v-if="input.commentMode == true"
                          >
                            <div class="topDiv">
                              <div>
                                <label class="newInt-inner-containers-subhead"
                                  >Comments</label
                                >
                              </div>
                              <div class="mt-1">
                                <b-form-textarea
                                  class="newInt-previewInputField"
                                  v-model="input.comments"
                                  placeholder="Enter"
                                  rows="3"
                                  max-rows="4"
                                >
                                </b-form-textarea>
                                <div
                                  v-if="
                                    !$v.skills.$each[index].comments.maxLength
                                  "
                                  class="error-txt-tc"
                                >
                                  Exceeded the max char length of 124
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="mt-3 givefdbck-blue-containers"
                        v-if="panelDetails.screenshot == true"
                      >
                        <UploadImage
                          :mandatory="true"
                          label="Candidate Screenshot"
                          placeholder="Select file"
                          type="upload_file"
                          id="panelFeedback"
                          @select-value="previewImage"
                          :maxFileSize="fileSize"
                          :fileFormat="['jpg', 'jpeg', 'png', 'webp']"
                          :showError="showErrorImage"
                        />
                      </div>
                    </template>
                  </div>
                </div>
              </div>
              <div
                class="
                  h-12
                  extp-footer
                  d-flex
                  justify-content-end
                  align-items-center
                "
              >
                <div class="d-flex align-items-center">
                  <!-- <div class="newoutline">
                    <b-button variant="padding-4-21 outline-primary mr-3"
                    :disabled="feedbackLoader"
                      >Cancel</b-button
                    >
                  </div> -->

                  <div
                    class="newprimarybtn relativeclass"
                    :class="feedbackLoader ? 'newprimarybtn-disabled ' : ''"
                  >
                    <b-button
                      class="padding-4-21"
                      @click="!feedbackLoader ? sendFeedback() : ''"
                    >
                      <span v-if="!feedbackLoader">Send</span>
                    </b-button>
                    <div v-if="feedbackLoader" class="loader-pos">
                      <Loader />
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="extpanel-blurry-images h-100 w-100"
                v-if="giveFeedback && interviewDetails.feedback === false"
              >
                <div
                  class="d-flex align-items-center justify-content-center h-100"
                >
                  <div class="extp-noti-box d-flex align-items-center">
                    <div>
                      <img
                        src="../../assets/img/extpanelnotischedule.svg"
                        alt=""
                      />
                    </div>
                    <div class="ml-3">
                      You cannot provide feedback to this candidate <br />
                      before the Scheduled time
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              class="
                w-40
                h-95
                ext-panelist-right-container
                my-3
                mr-3
                position-relative
              "
              v-else
            >
              <div class="ext-panelist-card-headings my-2 pl-3 pt-2">
                View Feedback
              </div>
              <hr />
              <div>
                <div class="px-3">
                  <div
                    class="h-100 overflow-auto newInt-preview-container pr-2"
                  >
                    <div class="position-relative" v-if="showRecOptions">
                      <SelectCustom
                        :disableDropdown="true"
                        :mandatory="true"
                        :placeholder="'Select'"
                        :values="getFilteredRecOptions"
                        :dropdown="true"
                        :disabled="true"
                        :vmodel="recOption"
                        :label="'Recommendation'"
                      />
                    </div>
                    <div v-else class="">
                      <div class="extp-recom-txt">
                        Recommendation<span class="asterik">*</span>
                      </div>
                      <div
                        class="
                          allocateradios
                          disabled-panel-radio
                          d-flex
                          align-items-center
                          mt-2
                        "
                      >
                        <b-form-radio
                          v-if="recommendation == 'S'"
                          v-model="recommendation"
                          name="some-radios"
                          value="S"
                          disabled
                        >
                          Select
                        </b-form-radio>
                        <b-form-radio
                          v-if="recommendation == 'R'"
                          v-model="recommendation"
                          name="some-radios"
                          value="R"
                          class="ml-3"
                          disabled
                        >
                          Reject
                        </b-form-radio>
                        <b-form-radio
                          v-if="recommendation == 'H'"
                          v-model="recommendation"
                          name="some-radios"
                          value="H"
                          class="ml-3"
                          disabled
                        >
                          Hold
                        </b-form-radio>
                        <b-form-radio
                          v-if="recommendation == 'DNA'"
                          v-model="recommendation"
                          name="some-radios"
                          value="DNA"
                          class="ml-3"
                          disabled
                        >
                          No Show
                        </b-form-radio>
                      </div>
                    </div>
                    <div>
                      <div class="jdk-ip-confirm-subtxt mt-3">
                        Remarks<span class="asterik">*</span>
                      </div>

                      <div class="mt-1">
                        <b-form-textarea
                          class="newInt-previewInputField"
                          v-model="recruiterRemarks"
                          disabled
                          rows="3"
                          max-rows="4"
                        >
                        </b-form-textarea>
                      </div>
                    </div>
                    <hr class="my-3" />
                    <div class="mt-3 extp-basicinfomartion">
                      <div class="newInt-preview-container-head">
                        Basic Info
                      </div>

                      <div class="mt-3 d-flex align-items-center">
                        <div class="extp-bi-heads" style="width: 40%">
                          Candidate Name
                        </div>

                        <div style="width: 60%">
                          <b-form-input
                            class="w-100"
                            v-model="candidateInfo.fullName"
                            disabled
                          >
                          </b-form-input>
                        </div>
                      </div>

                      <div class="mt-3 d-flex align-items-center">
                        <div class="extp-bi-heads" style="width: 40%">
                          Evaluation Date
                        </div>

                        <div style="width: 60%">
                          <b-form-input
                            class="w-100"
                            v-model="getCurrentDate"
                            disabled
                          >
                          </b-form-input>
                        </div>
                      </div>

                      <div class="mt-3 d-flex align-items-center">
                        <div class="extp-bi-heads" style="width: 40%">
                          Panel Name
                        </div>

                        <div style="width: 60%">
                          <b-form-input
                            class="w-100"
                            v-model="panelName"
                            disabled
                          >
                          </b-form-input>
                        </div>
                      </div>
                      <div class="mt-3 d-flex align-items-center">
                        <div class="extp-bi-heads" style="width: 40%">
                          Mode of Interview
                        </div>

                        <div style="width: 60%">
                          <b-form-input
                            class="w-100"
                            value="Face to Face"
                            disabled
                          >
                          </b-form-input>
                        </div>
                      </div>
                    </div>

                    <div
                      class="mt-3 newInt-inner-containers"
                      :class="input.markingType == 'rating' ? 'mb-2' : 'mb-0'"
                      v-for="(input, k) in skills"
                      :key="k"
                    >
                      <div>
                        <div
                          class="
                            w-100
                            exptp-inner-containers-head
                            text-truncate
                          "
                        >
                          {{ input.name
                          }}<span v-if="input.mandatory == true" class="asterik"
                            >*</span
                          >
                        </div>

                        <div
                          class="d-flex align-items-center"
                          v-if="input.markingType == 'rating'"
                        >
                          <div class="newInt-inner-containers-subhead">
                            Rating
                          </div>
                          <div class="extpanelist-rating-input">
                            <b-form-rating
                              variant="primary"
                              v-model="input.mark"
                              class="newInt-rating p-0 w-25 ml-2"
                              disabled
                            ></b-form-rating>
                          </div>
                        </div>

                        <div class="mt-2" v-if="input.markingType == 'score'">
                          <div class="topDiv d-flex align-items-center">
                            <div>
                              <label class="newInt-inner-containers-subhead"
                                >Score</label
                              >
                            </div>
                            <div class="ml-2">
                              <b-form-input
                                class="p-1 h37-w44 newInt-previewInputField"
                                v-model="input.mark"
                                disabled
                                type="number"
                              >
                              </b-form-input>
                            </div>
                            <div class="ml-1 newInt-preview-container-subFont">
                              Out of 10
                            </div>
                          </div>
                        </div>

                        <div class="mt-1" v-if="input.commentMode == true">
                          <div class="topDiv">
                            <div>
                              <label class="newInt-inner-containers-subhead"
                                >Comments</label
                              >
                            </div>
                            <div class="mt-1">
                              <b-form-textarea
                                class="newInt-previewInputField"
                                v-model="input.comments"
                                disabled
                                rows="3"
                                max-rows="4"
                              >
                              </b-form-textarea>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="mt-3 newInt-inner-containers"
                      v-if="
                        interviewResponse.candidateImage != null &&
                        interviewResponse.candidateImage != ''
                      "
                    >
                      <div class="exptp-inner-containers-head">
                        <img
                          src="../../assets/pssicon.svg"
                          class="mr-2"
                          alt=""
                        />
                        Candidate Screenshot<span class="asterik">*</span>
                      </div>
                      <div class="mt-2 extp-cand-ssbox">
                        <img
                          :src="image"
                          alt=""
                          class="w-100 h-100 overflow-hidden"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-overlay>
  </div>
</template>
<script>
import {
  required,
  requiredIf,
  between,
  maxLength,
} from "vuelidate/lib/validators";
import Loader from "../../components/fixedcomponents/Loader.vue";
import UploadImage from "../../components/InputComponents/UploadImage";

import toast from "../../components/mixin/toast";
import panelMixins from "../../views/panelLogin/panelMixins.js";
import { exportResume } from "../../controllers/panelLogin/asynchronous.js";
import SelectCustom from "../../components/InputComponents/SelectCustom";

import { getFeedbackFormfromUuid } from "../../utils/apiFunctions.js";
export default {
  name: "PanelDetails",
  components: {
    UploadImage,
    Loader,
    SelectCustom,
  },

  data() {
    return {
      interviewDetails: {},
      fileSize: "5",
      showErrorImage: false,
      feedbackLoader: false,
      jdName: "",
      candidateInfo: {},
      interviewResponse: {},
      modeOfInterview: "",
      fileCheckImage: false,
      showSpinner: false,
      panelName: "",
      skills: [],
      getCurrentDate: "",
      candidateImage: "",
      isFailed: false,
      checkimage: false,
      LoaderStatus: false,
      automatic: false,
      image: "",
      screenshotname: "",
      customFeedback: {},
      processedBy: "Panel",
      recruiterRemarks: "",

      panelDetails: {},

      candidateName: "",
      recommendation: "",
      recOption: "",
      thirdPartyData: {},
    };
  },
  computed: {
    showRecOptions() {
      if (this.thirdPartyData?.feedbackTypeID == "FEEDBACK2") return true;
      return false;
    },
    getFilteredRecOptions() {
      if (this.showRecOptions) {
        return Object.entries(this.thirdPartyData.feedbackLevelOptions).map(
          ([key, label]) => {
            return { key, label };
          }
        );
      }
      return [];
    },
    giveFeedback() {
      try {
        let result;
        const currentDate = new Date();
        const startTime = new Date(this.interviewDetails.startTime);
        const startTimeLocal = new Date(
          startTime.toLocaleString("en-US", { timeZone: "UTC" })
        );

        // Compare dates
        if (startTimeLocal > currentDate) {
          result = true;
        } else {
          result = false;
        }

        return result;
      } catch (error) {
        return false;
      }
    },
  },
  mixins: [toast, panelMixins],

  validations() {
    return {
      recruiterRemarks: {
        required,
        maxLength: maxLength(256),
      },

      recommendation: { required },
      recOption: {
        required: requiredIf(() => this.showRecOptions),
      },
      image: { required },

      skills: {
        $each: {
          comments: {
            required: requiredIf((obj) => obj.commentMode),
            maxLength: maxLength(124),
          },
          mark: {
            required: requiredIf((obj) => obj.markingType != ""),
            between: between(1, 10),
          },
        },
      },
    };
  },

  methods: {
    previewImage(data) {
      this.candidateImage = data;
    },
    async exportResume(data) {
      await exportResume(data, this);
    },
    // Method to fetch panel details

    async getPanelDetails() {
      this.showSpinner = true;
      try {
        // Prepare the payload for the API request
        let payload = {
          uuid: this.$route.query.uuid,
        };

        // Fetch panel details using the payload
        const response = await getFeedbackFormfromUuid(payload);
        if (response.status == 200) {
          this.showSpinner = false;
        } else if (response.status === 401 || response.status === 404) {
          this.$router.push({ path: "/404" });
        }

        // Store fetched panel details in component properties
        this.automatic =
          response.data.data.interviewDetails.interviewRound.automated;
        this.panelDetails = response.data.data;
        this.interviewResponse = response.data.data.interviewResponse;
        this.thirdPartyData = response.data.data.configuration;
        this.jdName = response.data.data.jobName;
        this.interviewDetails = response.data.data.interviewDetails;
        this.panelName = this.extPanel;
        this.modeOfInterview = this.interviewDetails.interviewRound.type;

        this.candidateInfo = response.data.data.candidateInfo;
        this.skills = response.data.data.skills;

        if (
          this.candidateInfo.experience == "" ||
          this.candidateInfo.experience == null ||
          this.candidateInfo.experience == undefined
        ) {
          this.candidateInfo.experience = "Not Disclosed";
        }

        this.getPanelResponse();
      } catch (error) {
        console.error("Error in getPanelDetails:", error);
        if (error.response.status === 401 || error.response.status === 404) {
          this.$router.push({ path: "/404" });
        }
      }
    },
    getPanelResponse() {
      if (this.interviewDetails.feedback) {
        this.image = this.interviewResponse.candidateImage;
        this.screenshotname = this.interviewResponse.candidateImageKey;

        this.recommendation = this.interviewResponse.recommendation;
        if (this.panelDetails.feedbackText && this.showRecOptions) {
          this.recOption = Object.keys(
            this.thirdPartyData.feedbackLevelOptions
          ).find(
            (key) =>
              this.thirdPartyData.feedbackLevelOptions[key] ===
              this.panelDetails.feedbackText
          );
        }
        const date = new Date(this.interviewResponse.evalDate);

        // Extract day, month, and year components
        const day = date.getDate();
        const month = date.getMonth() + 1; // Adding 1 because months are zero-based
        const year = date.getFullYear();

        // Create a formatted date string in DD-MM-YYYY format
        const formattedDate = `${day}-${month}-${year}`;

        this.getCurrentDate = formattedDate;

        this.recruiterRemarks = this.interviewResponse.recruiterRemarks;
        this.skills = this.interviewResponse.customFeedback.skills;
        this.getPanelSkills();
      }
    },
    getPanelSkills() {
      for (const i of this.skills) {
        for (const j of this.interviewResponse.customFeedback.skills) {
          if (i.commentMode) {
            i.comments = j.comments;
          }
          if (i.markingType == "score") {
            i.mark = j.mark;
          }
          if (i.markingType == "rating") {
            this.skills[i].mark = j.mark;
          }
        }
      }
    },
  },
};
</script>
<style>
.loader-pos {
  position: absolute;
  top: -54px;
  z-index: 1;
  left: -2px;
}
.recomendation-error .custom-control-label::before {
  border: 1px solid red;
}

.disabled-panel-radio
  .custom-control-input[disabled]
  ~ .custom-control-label::before,
.custom-control-input:disabled ~ .custom-control-label::before {
  top: 4px !important;
}
</style>
